import { Model } from 'pinia-orm';
import { Attr, BelongsTo, HasMany, HasManyThrough, Num, Str } from 'pinia-orm/dist/decorators';
import PackageClaim from './PackageClaim';
import PackageTender from './PackageTender';
import PackageTradeItem from './PackageTradeItem';
import Project from './Project';
import Supplier from './Supplier';
import TradeItem from './TradeItem';
import VariationOrder from './VariationOrder';
import WbsCode from './WbsCode';
/* --- user header --- */
/* --- end user header --- */

export default class Package extends Model {
  static entity = 'App\\Models\\Package';
  // fields
  @Num(0)
  declare id: number;
  @Str('')
  declare name: string;
  @Num(0)
  declare subcontractor_id: number;
  @Num(0)
  declare project_id: number;
  @Num(0)
  declare wbs_code_id: number;
  @Num(0)
  declare retention: number;
  @Str(undefined)
  declare contract_start_date: string | undefined;
  @Str(undefined)
  declare contract_end_date: string | undefined;
  @Str(undefined)
  declare contract_reference: string | undefined;
  @Num(undefined)
  declare liquidated_damages_value: number | undefined;
  @Str(undefined)
  declare liquidated_damages_rate: string | undefined;
  @Str(undefined)
  declare performance_security: string | undefined;
  @Num(undefined)
  declare claim_retention_percent: number | undefined;
  @Num(undefined)
  declare total_retention_percent: number | undefined;
  @Str('')
  declare procurement_method: string | undefined;
  @Str(undefined)
  declare form_of_subcontract: string | undefined;
  @Str(undefined)
  declare risk_level: string | undefined;
  @Str('')
  declare created_at: string;
  @Str('')
  declare updated_at: string;
  @Str(undefined)
  declare locked_at: string | undefined;

  // relations
  @BelongsTo(() => Project, 'project_id', 'id')
  declare project: Project;
  @BelongsTo(() => WbsCode, 'wbs_code_id', 'id')
  declare wbs_code: WbsCode;
  @BelongsTo(() => Supplier, 'subcontractor_id', 'id')
  declare subcontractor: Supplier;
  @HasMany(() => PackageTradeItem, 'package_id', 'id')
  declare package_trade_items: PackageTradeItem[];
  @HasManyThrough(() => TradeItem, () => PackageTradeItem, 'package_id', 'id', 'id', 'trade_item_id')
  declare trade_items: TradeItem[];
  @HasMany(() => PackageClaim, 'package_id', 'id')
  declare package_claims: PackageClaim[];
  @HasMany(() => VariationOrder, 'package_id', 'id')
  declare variation_orders: VariationOrder[];
  @HasMany(() => PackageTender, 'package_id', 'id')
  declare tenders: PackageTender[];
  /* --- user code --- */
  @Attr(undefined)
  declare $total_budget: number | undefined;
  @Attr(undefined)
  declare $total_awarded: number | undefined;
  @Attr(undefined)
  declare $total_approved_variation: number | undefined;
  /* --- end user code --- */

  public get totalBudget(): number {
    return this.$total_budget ?? this.trade_items?.reduce((total, tradeItem) => {
      return total + tradeItem.budget;
    }, 0) ?? 0;
  }

  public get totalAwarded(): number {
    return this.$total_awarded ?? this.package_trade_items?.reduce((total, packageTradeItem) => {
      return total + packageTradeItem.value;
    }, 0) ?? 0;
  }

  public get totalApprovedVariation(): number {
    return this.$total_approved_variation;
  }

  public get budgetIncludingPackages(): number {
    return this.totalBudget - (this.package_trade_items?.reduce((total, packageTradeItem) => {
      return total +
        ((packageTradeItem.trade_item?.budget ?? 0) - (packageTradeItem.trade_item?.$profit ?? 0) -
          packageTradeItem.value);
    }, 0) ?? 0);
  }

  public get budgetWithAwardedWorks(): number {
    return this.package_trade_items?.reduce((total, packageTradeItem) => {
      return total + ((packageTradeItem.trade_item?.budget ?? 0) * (packageTradeItem.awarded_works / 100));
    }, 0) ?? 0;
  }
}
